import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_STEP {
  summary = 'summary',
  email = 'email',
  payment = 'payment',
}

export enum MODULE_ROUTE {
  payment = 'PricingPaymentSubscription',
}

const isMobile = window.innerWidth < 768;

export const routes: RouteRecordRaw[] = isMobile
  ? [
      {
        path: '/:lang?/pricing/subscription/payment/',
        component: () =>
          import('@/modules/subscription/mobile/layout/LayoutPage.vue'),
        children: [
          {
            path: '',
            name: MODULE_ROUTE.payment,
            component: () =>
              import('@/modules/subscription/mobile/pages/DynamicPage.vue'),
            meta: {
              i18nAlias: 'pricing',
            },
          },
        ],
      },
    ]
  : [
      {
        path: '/:lang?/pricing/subscription/payment/',
        component: () => import('@/modules/subscription/layout/LayoutPage.vue'),
        children: [
          {
            path: '',
            name: MODULE_ROUTE.payment,
            component: () =>
              import('@/modules/subscription/pages/payment/PagePayment.vue'),
            meta: {
              i18nAlias: 'pricing',
            },
          },
        ],
      },
    ];
